import Container from "./container";

const ShopByBrands = (props) => {
  const { logos } = props;

  return (
    <div className="bg-white py-5">
      <Container className={"space-y-5 md:space-y-10"}>
        <p className="text-center  text-2xl md:text-3xl">Shop by Brands</p>
        <div className="grid grid-cols-7 md:grid-cols-12 lg:[grid-template-columns: repeat(16, minmax(0, 1fr));] gap-2 md:gap-4">
          {logos?.map((logo, idx) => {
            return (
              <div key={idx}>
                <img
                  src={logo}
                  alt={`logo ${idx}`}
                  className="w-full h-full object-cover"
                />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default ShopByBrands;
